import React from "react";

export const Logo = () => {
  return (
    <div className="text-xl font-semibold flex">
      <p className="text-indigo-400	font-mono">Michał Krawiec&apos;s</p>
      &nbsp;website
    </div>
  );
};
